import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const comingSoonFeatures = [
  {
    title: 'SW Change Verification Assessment',
    description: 'Verification assessment of potential issues caused by hardware modifications',
  
  },
  {
    title: 'Project Reporting Hub',
    description: 'Centralized hub for tracking project progress and certification status',
  },
  {
    title: 'Vendor Capability',
    description: 'Evaluation and tracking of vendor capabilities and performance',
  },
  {
    title: 'Certification',
    description: 'tracking project progress',
  }
];

const ComingSoonTemplate = ({ featureName, description }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-4">
      <div className="max-w-3xl w-full bg-gray-800 rounded-lg p-8 text-center">
        {/* Back button */}
        <div className="flex items-center justify-start mb-6">
          <button
            onClick={handleGoBack}
            className="p-2 rounded-full hover:bg-gray-700 transition-colors"
            aria-label="Go back"
          >
            <ArrowLeft className="w-6 h-6" />
          </button>
        </div>

        {/* Main content */}
        <div className="mb-10">
          <h1 className="text-3xl font-bold text-blue-400 mb-2">{featureName}</h1>
          <h2 className="text-3xl font-bold text-blue-400 mb-4">Coming Soon</h2>
          
          <p className="text-gray-300 text-lg">
            {description || 'This feature is not yet implemented.'}
          </p>
          
          <p className="text-gray-400 mt-2">
            Our team is working hard to bring this functionality to you soon!
          </p>
        </div>

        {/* Animated skeleton loader */}
        <div className="animate-pulse">
          <div className="h-4 bg-gray-700 rounded-full w-3/4 mx-auto mb-2" />
          <div className="h-4 bg-gray-700 rounded-full w-1/2 mx-auto" />
        </div>
      </div>
    </div>
  );
};

export const SWChangeVerificationAssessment = () => (
  <ComingSoonTemplate
    featureName="SW Change Verification Assessment"
    description="Verification assessment of potential issues caused by hardware modifications"
  />
);

export const ProjectReportingHub = () => (
  <ComingSoonTemplate
    featureName="Project Reporting Hub"
    description="Centralized hub for tracking project progress and certification status"
  />
);

export const VendorCapability = () => (
  <ComingSoonTemplate
    featureName="Vendor Capability"
    description="Evaluation and tracking of vendor capabilities and performance"
  />
);
export const Certification = () => (
  <ComingSoonTemplate
    featureName="Certification"
    description="tracking project progress"
  />
);

export default {
  SWChangeVerificationAssessment,
  ProjectReportingHub,
  VendorCapability,
  Certification
};